export async function getPlaces(slug, eventName) {
  const url =
    "https://rrfarsgehb.execute-api.eu-west-3.amazonaws.com/dev/places";
  const params = new URLSearchParams({
    cs: slug,
    eventName: eventName,
  });

  try {
    const response = await fetch(`${url}?${params}`);
    const data = await response.json();
    return data[0];
  } catch (error) {
    console.error(error);
    // Gestion de l'erreur
  }
}

export async function userExtract(
  email,
  phone,
  event,
  area,
  game,
  name,
  firstName,
  optin,
  slug
) {
  const today = new Date();
  const formattedDate = today.toISOString().slice(0, 10);
  const data = {
    cs: slug,
    uploadDate: formattedDate,
    event: event,
    area: area,
    game: game,
    userEmail: email,
    phone: phone,
    userName: name,
    userFirstname: firstName,
    optin: optin,
    company: "",
  };

  const params = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data), // Convertir l'objet data en chaîne JSON
  };

  try {
    const response = await fetch(
      process.env.REACT_APP_DATALAKE_ENDPOINT,
      params
    );
    if (response.ok) {
      console.log("Data sent successfully:", await response.json());
    } else {
      console.error("Error sending data:", response.statusText);
    }
  } catch (error) {
    console.error("Error sending data:", error);
  }
}
